module.exports = __webpack_public_path__ + "img/Group 427320726@2x.ec601ca2.png";